const SITE = "https://vetrodesignitalia.it";
export const ORG_ID = `${SITE}/#organization`;

// Social / Google Business Profile
const SAME_AS = [
  "https://www.facebook.com/profile.php?id=61592217743131",
  "https://maps.app.goo.gl/TCxM4YF7NboUn7Ar6",
];

export const organizationSchema = {
  "@type": ["Organization", "LocalBusiness"],
  "@id": ORG_ID,
  name: "Vetro Design Italia S.r.l.",
  legalName: "VETRO DESIGN ITALIA S.r.L.",
  url: SITE,
  logo: `${SITE}/logo-vdi.png`,
  image: `${SITE}/logo-vdi.png`,
  telephone: "+39 379 1951206",
  email: "info@vetrodesignitalia.it",
  address: {
    "@type": "PostalAddress",
    streetAddress: "Via G. Agnelli 6",
    addressLocality: "Osimo",
    addressRegion: "AN",
    postalCode: "60027",
    addressCountry: "IT",
  },
  geo: { "@type": "GeoCoordinates", latitude: 43.4857, longitude: 13.4818 },
  areaServed: { "@type": "AdministrativeArea", name: "Marche" },
  openingHoursSpecification: [
    {
      "@type": "OpeningHoursSpecification",
      dayOfWeek: ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday"],
      opens: "08:30",
      closes: "12:30",
    },
    {
      "@type": "OpeningHoursSpecification",
      dayOfWeek: ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday"],
      opens: "14:30",
      closes: "18:30",
    },
  ],
  ...(SAME_AS.length ? { sameAs: SAME_AS } : {}),
};

export const websiteSchema = {
  "@type": "WebSite",
  "@id": `${SITE}/#website`,
  name: "Vetro Design Italia",
  url: SITE,
  publisher: { "@id": ORG_ID },
  potentialAction: {
    "@type": "SearchAction",
    target: { "@type": "EntryPoint", urlTemplate: `${SITE}/blog?search={search_term_string}` },
    "query-input": "required name=search_term_string",
  },
};

export const globalGraph = {
  "@context": "https://schema.org",
  "@graph": [organizationSchema, websiteSchema],
};

export const buildWebPage = (name, path, description, breadcrumb) => {
  const webpage = {
    "@type": "WebPage",
    "@id": `${SITE}${path}#webpage`,
    name,
    url: `${SITE}${path}`,
    description,
    isPartOf: { "@id": `${SITE}/#website` },
    about: { "@id": ORG_ID },
  };
  const graph = [webpage];
  if (breadcrumb) {
    graph.push({
      "@type": "BreadcrumbList",
      itemListElement: [
        { "@type": "ListItem", position: 1, name: "Home", item: `${SITE}/` },
        { "@type": "ListItem", position: 2, name: breadcrumb, item: `${SITE}${path}` },
      ],
    });
  }
  return { "@context": "https://schema.org", "@graph": graph };
};
